/**
 * Fonte unica das mensagens da "Comunicacao entre contas" (LO Santander),
 * usada na listagem, no drawer hub-lo e no cadastro de conta.
 */
export enum LoMessages {
    // Dados bancarios - listagem (modal)
    ListDeleteBlockedTitle = 'Antes de excluir, remova a comunicação entre contas',
    ListDeleteBlockedBody = 'Esta conta está vinculada à comunicação entre contas. Para excluí-la, primeiro use a opção <b>Remover comunicação entre contas</b> no card desta conta.',

    // Drawer (hub-lo) - resultado da autorizacao
    DrawerSuccessTitle = 'Cadastro de conta concluído',
    DrawerSuccessBody = 'Os dados da sua conta foram registrados com sucesso. A comunicação entre contas será ativada no próximo dia útil.',
    DrawerOwnershipInvalidTitle = 'Cadastre uma conta da mesma titularidade para continuar',
    DrawerOwnershipInvalidBody = 'A conta cadastrada precisa ser da sua titularidade para habilitar a comunicação.',
    DrawerDivergentWarning = 'Para sua segurança, você pode excluir esta conta a qualquer momento. Lembre-se: é necessário manter pelo menos uma conta cadastrada.',
    DrawerFailureTitle = 'Erro ao tentar processar sua solicitação',
    DrawerFailureBody = 'Identificamos um erro e não conseguimos concluir seu pedido. Por favor, tente novamente mais tarde.',

    // Dados bancarios - cadastro/edicao de conta (edit-bankdata)
    EditOwnershipInfoTitle = 'Atenção ao titular da conta',
    EditOwnershipInfoBody = 'Certifique-se de que a conta cadastrada pertence a você. Por questões de segurança, não é permitido o cadastro de contas de terceiros.',
    EditOwnershipLoading = 'Verificando a titularidade...',
    EditOwnershipInvalidInline = 'Titularidade Inválida',
    EditOwnershipInvalidBox = 'Os dados bancários informados devem <strong>pertencer ao titular do cadastro</strong>. Verifique os dados e tente novamente.',
}
